import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Reply } from '@plugins/client/post/post-comments/types';
import type {
  CommentResponseDto,
  CreateCommentResponseDto,
  VoteDto,
} from '@plugins/faq-lib/types';
import { CreateReply, UpdateReply } from '@plugins/shared/types/post/response';

@Injectable({
  providedIn: 'root',
})
export class CommentService {
  private readonly http = inject(HttpClient);

  get(commentId: string) {
    return this.http.get<Reply>(`/api/answer/comment/${commentId}`);
  }

  create(comment: CreateReply) {
    return this.http.post<CreateCommentResponseDto>(
      `/api/answer/${comment.answerId}/comment`,
      comment,
    );
  }

  update(comment: UpdateReply) {
    return this.http.patch<CommentResponseDto>(
      `/api/answer/comment/${comment.id}`,
      comment,
    );
  }

  delete(commentId: string) {
    return this.http.delete<CommentResponseDto>(
      `/api/answer/comment/${commentId}`,
    );
  }

  like(commentId: string) {
    return this.http.get<VoteDto>(`/api/answer/comment/${commentId}/like`);
  }
}
